import axios from "@/plugins/axios";

let url = "/api/console/cashes";

export const cashes = {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
}
